<template>
    <div id="app__wrap" :class="['app__wrap', !loaded ? 'loading' : '']">
        <MarksModelSelection
            :step="currentStep"
            ref="markAndModel"
            :API_URL="API_URL"
            v-on:resetEngines="resetEngines"
            v-on:goToStep="setAppStep"
            v-on:getEnginesFromApi="getEnginesFromApi"
        />
        <EngineSelection
            :step="currentStep"
            :availableStep="availableStep"
            ref="engines"
            v-on:resetWorks="resetWorks"
            v-on:goToStep="setAppStep"
            v-on:getWorksFromApi="getWorksFromApi"
            :API_URL="API_URL"
        ></EngineSelection>
        <WorksSelection
            :step="currentStep"
            :availableStep="availableStep"
            ref="works"
            :rate="rate"
            :API_URL="API_URL"
            v-on:goToStep="setAppStep"
            v-on:loader="loader"
            :assets_url="assets_url"
        ></WorksSelection>
        <div class="loadingio-spinner-double-ring-ys9owgj7jy">
            <div class="ldio-2m0ap7c4mqj">
                <div></div>
                <div></div>
                <div><div></div></div>
                <div><div></div></div>
            </div>
        </div>

        <div class="popup-cart open" v-if="cartPopupIsOpened">
            <FormApiCart
                :assets_url="assets_url"
                v-bind:is-popup="true"
                v-on:goToStep="setAppStep"
                v-on:closeCartPopup="closeCartPopup"
            ></FormApiCart>

            <div class="overlay" @click="closeCartPopup"></div>
        </div>
    </div>
</template>

<script>
import MarksModelSelection from "./parts/MarksModelSelection";
import EngineSelection from "./parts/EngineSelection";
import WorksSelection from "./parts/WorksSelection";
import FormApiCart from "./parts/FormApiCart";
export default {
    components: {
        MarksModelSelection: MarksModelSelection,
        EngineSelection: EngineSelection,
        WorksSelection: WorksSelection,
        FormApiCart: FormApiCart,
    },
    props: {
        assets_url: {
            type: String,
        },
        rate: {
            type: Number,
            default: 0,
        },
        API_URL: {
            type: String,
            default: "https://wscapi.shate-m.com/api/common/vehicle/",
        },
    },
    data: () => ({
        loaded: true,
    }),
    
    methods: {
        resetEngines() {
            this.$refs.engines.resetEngines();
            this.$store.dispatch("updateStateValue", {
                target: "maxAvailableStep",
                value: 1,
            });
        },
        resetWorks() {
            this.$refs.works.resetWorks();
            this.$store.dispatch("updateStateValue", {
                target: "maxAvailableStep",
                value: 2,
            });
        },
        setAppStep(step) {
            this.$store.dispatch("setStep", step).then(() => {
                setTimeout(() => {
                    $(".app")[0].scrollIntoView({ block: "center" });
                }, 500);
            });
        },
        getEnginesFromApi() {
            this.$refs.engines.getEnginesFromApi();
        },
        getWorksFromApi() {
            this.$refs.works.getWorksFromApi();
        },
        closeCartPopup() {
            this.$store.dispatch("updateStateValue", {
                target: "cartPopupIsOpened",
                value: false,
            });

            document.querySelector("body").style.overflow = "";
        },
        loader() {
            this.loaded = !this.loaded;
        },
    },
    computed: {
        currentStep: function () {
            return this.$store.getters.getActiveStep;
        },
        availableStep: function () {
            return this.$store.getters.getAvailableStep;
        },
        cartPopupIsOpened: function () {
            let q = document.querySelectorAll("section:not(.app)");
            q.forEach((item) => {
                if (this.$store.getters.cartPopupIsOpened) {
                    item.style.filter = "blur(0)";
                } else {
                    item.style.filter = "";
                }
            });
            return this.$store.getters.cartPopupIsOpened;
        },
    },
};
</script>
<style lang="css">
@keyframes ldio-2m0ap7c4mqj {
    0% {
        transform: rotate(0);
    }
    100% {
        transform: rotate(360deg);
    }
}
.loadingio-spinner-double-ring-ys9owgj7jy {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    display: none;
    background: rgb(0, 0, 0, 0.2);
}
.loading .loadingio-spinner-double-ring-ys9owgj7jy {
    display: block;
}
.ldio-2m0ap7c4mqj {
    display: flex;
    align-items: center;
    justify-content: center;
}
.ldio-2m0ap7c4mqj div {
    box-sizing: border-box !important;
}
.ldio-2m0ap7c4mqj > div {
    position: absolute;
    width: 118px;
    height: 118px;

    border-radius: 50%;
    border: 14px solid #000;
    border-color: #ffffff transparent #ffffff transparent;
    animation: ldio-2m0ap7c4mqj 1s linear infinite;
}

.ldio-2m0ap7c4mqj > div:nth-child(2),
.ldio-2m0ap7c4mqj > div:nth-child(4) {
    width: 86px;
    height: 86px;

    animation: ldio-2m0ap7c4mqj 1s linear infinite reverse;
}
.ldio-2m0ap7c4mqj > div:nth-child(2) {
    border-color: transparent #ed0b0d transparent #ed0b0d;
}
.ldio-2m0ap7c4mqj > div:nth-child(3) {
    border-color: transparent;
}
.ldio-2m0ap7c4mqj > div:nth-child(3) div {
    position: absolute;
    width: 100%;
    height: 100%;
    transform: rotate(45deg);
}
.ldio-2m0ap7c4mqj > div:nth-child(3) div:before,
.ldio-2m0ap7c4mqj > div:nth-child(3) div:after {
    content: "";
    display: block;
    position: absolute;
    width: 14px;
    height: 14px;
    top: -14px;
    left: 38px;
    background: #ffffff;
    border-radius: 50%;
    box-shadow: 0 104px 0 0 #ffffff;
}
.ldio-2m0ap7c4mqj > div:nth-child(3) div:after {
    left: -14px;
    top: 38px;
    box-shadow: 104px 0 0 0 #ffffff;
}

.ldio-2m0ap7c4mqj > div:nth-child(4) {
    border-color: transparent;
}
.ldio-2m0ap7c4mqj > div:nth-child(4) div {
    position: absolute;
    width: 100%;
    height: 100%;
    transform: rotate(45deg);
}
.ldio-2m0ap7c4mqj > div:nth-child(4) div:before,
.ldio-2m0ap7c4mqj > div:nth-child(4) div:after {
    content: "";
    display: block;
    position: absolute;
    width: 14px;
    height: 14px;
    top: -14px;
    left: 22px;
    background: #ed0b0d;
    border-radius: 50%;
    box-shadow: 0 72px 0 0 #ed0b0d;
}
.ldio-2m0ap7c4mqj > div:nth-child(4) div:after {
    left: -14px;
    top: 22px;
    box-shadow: 72px 0 0 0 #ed0b0d;
}

.ldio-2m0ap7c4mqj {
    width: 100%;
    height: 100%;
    position: relative;
    transform: translateZ(0) scale(1);
    backface-visibility: hidden;
    transform-origin: 0 0; /* see note above */
}
.ldio-2m0ap7c4mqj div {
    box-sizing: content-box;
}
/* generated by https://loading.io/ */
</style>